import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="header-container">
        <Link to="/" className="header-logo" aria-label="FindMeAgent home" data-testid="header-logo-link">
          <div className="logo-icon">
            <span className="logo-text">FM</span>
          </div>
          <span className="logo-name">FINDMEAGENT</span>
        </Link>

        <nav className="header-nav desktop-nav">
          <Link to="/how-it-works" className="nav-link" data-testid="nav-how-it-works">How It Works</Link>
          <Link to="/why-us" className="nav-link" data-testid="nav-why-us">Why Us</Link>
          <Link to="/compare-agents" className="nav-link" data-testid="nav-compare-agents">Compare Agents</Link>
          <Link to="/real-estate-agent-fees-australia" className="nav-link" data-testid="nav-agent-fees">Agent Fees</Link>
          <Link to="/faq" className="nav-link" data-testid="nav-faq">FAQ</Link>
          <Link to="/free-property-appraisal" className="nav-cta" data-testid="nav-get-started">Free Appraisal</Link>
        </nav>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {isMobileMenuOpen && (
        <nav className="mobile-nav">
          {[
            ['/how-it-works', 'How It Works'],
            ['/why-us', 'Why Us'],
            ['/compare-agents', 'Compare Agents'],
            ['/real-estate-agent-fees-australia', 'Agent Fees'],
            ['/faq', 'FAQ'],
          ].map(([to, label]) => (
            <Link key={to} to={to} className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)} data-testid={`mobile-nav-${to.slice(1)}`}>
              {label}
            </Link>
          ))}
          <Link to="/free-property-appraisal" className="mobile-cta" onClick={() => setIsMobileMenuOpen(false)} data-testid="mobile-nav-get-started">
            Free Appraisal
          </Link>
        </nav>
      )}
    </header>
  );
};

export default Header;
